import {IS_IOS} from '#/env'

/**
 * Remote push is temporarily limited to iOS while Android has no configured
 * push provider. The in-app notification feed remains available everywhere.
 */
export const PUSH_NOTIFICATIONS_ENABLED = IS_IOS
